import { sentryAddBreadcrumb } from 'utils/sentry';

/**
 * Fallback for when the async clipboard API is unavailable or fails
 * (e.g., document not focused, permission denied, older browsers).
 */
function fallbackCopy(text: string) {
    const tempInput = document.createElement('input');
    tempInput.style.position = 'fixed';
    tempInput.style.opacity = '0';
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.focus();
    tempInput.select();
    try {
        const copyResult = document.execCommand('copy');
        if (!copyResult) {
            throw Error('Failed to copy to clipboard using legacy API');
        }
    } finally {
        document.body.removeChild(tempInput);
    }
}

export async function copyToClipboard(text: string) {
    if ('clipboard' in navigator) {
        try {
            await navigator.clipboard.writeText(text);
            return;
        } catch (error) {
            sentryAddBreadcrumb({
                category: 'clipboard.copy',
                message: 'Clipboard API failed, falling back to legacy method',
                level: 'warning',
                data: {
                    error: error instanceof Error ? error.message : String(error),
                    documentHasFocus: document.hasFocus(),
                    url: window.location.href,
                },
            });
        }
    }
    fallbackCopy(text);
}
